export default __webpack_public_path__ + "static/logo_menu_mb-02a66ae688e43b7e46acad9b62671bc8.png";